import { Modal, ModalProps } from "@cpj-ai/panel-npm-package";

export type TermsAndConditionModalProps = Pick<ModalProps, "isOpen" | "onClose" | "onOpenChange">;

export const TermsAndConditionModal: React.FC<TermsAndConditionModalProps> = ({ isOpen, onClose, onOpenChange }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onOpenChange={onOpenChange}
      label="Terms and Conditions"
      bodyContent={
        <div className="py-4 flex flex-col gap-4">
          <p>By logging in and using the CPJ application, you agree to the following terms: </p>
          <div>
            <span className="font-semibold">1. Registration and Identity Verification:</span>
            <p>
              By providing information such as your email and phone number, you agree that these details may be used to
              verify your identity and facilitate the hiring process.
            </p>
          </div>

          <div>
            <span className="font-semibold">2. Privacy and Data Security: </span>
            <p>
              CPJ is committed to maintaining the confidentiality and security of your information. All personal data is
              encrypted and will only be accessible to employers with your permission.
            </p>
          </div>

          <div>
            <span className="font-semibold">3. User Responsibility:</span>
            <p>You are responsible for ensuring that the information you provide is accurate and up to date. </p>
          </div>

          <div>
            <span className="font-semibold">4. Changes to Terms:</span>
            <p>
              CPJ reserves the right to update these Terms of Use at any time. Please review this section periodically
              to stay informed of any changes.
            </p>
          </div>
        </div>
      }
    />
  );
};
